var _rect, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFintelligenceReportIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "url(#paint0_linear_6_3260)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0472 12.3102C27.4939 12.67 29.7246 13.8213 31.4517 15.4764H35.6254C33.3227 11.9504 29.5088 9.50372 25.1192 9.07196C24.6154 9 24.0398 9 23.536 9C22.9604 9 22.4566 9 21.9529 9.07196C20.8015 9.21588 19.7221 9.43176 18.7147 9.79156C17.5633 10.2233 16.4839 10.727 15.4765 11.3747C11.9504 13.6774 9.50372 17.4913 9.07196 21.8809C9 22.3846 9 22.9603 9 23.464C9 24.0397 9 24.5434 9.07196 25.0472C9.57568 29.4367 12.0223 33.2506 15.4765 35.5534V31.5236C13.8214 29.8685 12.67 27.6377 12.3102 25.1191C12.2382 24.6154 12.1663 24.0397 12.1663 23.536C12.1663 22.9603 12.2382 22.4566 12.3102 21.9529C12.67 19.5062 13.8214 17.2754 15.4765 15.5484C16.4119 14.6129 17.4913 13.8213 18.7147 13.2457C19.7221 12.7419 20.8015 12.4541 21.9529 12.3102C22.4566 12.2382 23.0323 12.1663 23.536 12.1663C23.9678 12.1663 24.5435 12.2382 25.0472 12.3102Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6898 25.1913C33.9702 30.1565 30.0124 34.1144 25.0471 34.834V38.0002C31.8114 37.2806 37.2084 31.8836 37.928 25.1193C38 24.6156 38 24.0399 38 23.5362C38 22.9605 38 22.4568 37.928 21.9531C37.7841 20.8017 37.5682 19.7223 37.2084 18.7148H18.5706V21.9531H34.6179C34.6898 22.4568 34.7618 23.0325 34.7618 23.5362C34.7618 24.1119 34.7618 24.6156 34.6898 25.1913ZM18.5706 37.2806C19.5781 37.6404 20.6575 37.8563 21.8089 38.0002V28.3575H29.9404C30.66 27.4221 31.1637 26.3426 31.3796 25.1193H18.5706V37.2806Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_3260",
    x1: 5.54082e-9,
    y1: 0.264664,
    x2: 49.2178,
    y2: 46.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#937ABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#492A7B"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFintelligenceReportIcon);
export default __webpack_public_path__ + "static/media/FintelligenceReportIcon.4539dc3ad4d24628df8a3df1a8dd496c.svg";
export { ForwardRef as ReactComponent };